export default "__VITE_ASSET__iJlokkiY__"